<template>
  <div class="add-task-container">
    <b-row class="ml-0 d-flex flex-wrap w-100">
      <ValidationObserver ref="addTaskRef" class="col-md-12 d-flex">
        <b-col xl="9" lg="12" md="12" cols="12">
          <!-- Breadcrumbs -->
          <b-breadcrumb
            class="position-relative breadcrumb-container-left pb-2"
          >
            <b-breadcrumb-item v-if="showPABreadcrumb">
              <span
                @click="$router.push({ name: 'ViewPADirectory' })"
                class="text-uppercase font-family-medium"
              >
                Team Directory
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if="showPABreadcrumb">
              <span
                @click="goToPAContactInfo"
                class="text-uppercase font-family-medium"
              >
                {{ assistantFullName }}
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if="showCustomersBreadcrumb">
              <span
                @click="navigateToCustomers"
                class="text-uppercase font-family-medium"
              >
                Customers
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if="showCustomersBreadcrumb">
              <span
                @click="navigateToCustomerDetails"
                class="text-uppercase font-family-medium"
              >
                {{ customerFullName }}
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item>
              <span @click="navigateToTasks" class="font-family-medium">
                Tasks
              </span>
            </b-breadcrumb-item>

            <b-breadcrumb-item active>
              <span class="font-family-medium">Add New Task</span>
            </b-breadcrumb-item>
          </b-breadcrumb>
          <h1 class="font-lg font-family-medium primary--text content-title">
            Add New Task
          </h1>
          <div class="d-flex justify-content-end show-timer-container">
            <!-- Countdown timer -->
            <TimerComponent
              v-if="showTimer"
              :timeText="formatted"
              :stopAt="stopAt"
              :selfTask="true"
              :selectedStatus="selectedStatus"
              @stopTimer="stopTimer"
              @startTimer="startTimer"
            />
            <!-- Countdown timer -->
          </div>
          <b-dropdown-divider
            class="ml-2 tasks-dropdown-divider "
          ></b-dropdown-divider>
          <!-- only will be displayed on smaller screens -->
          <b-container fluid class="outer-container">
            <b-row class="customer-info-box-row">
              <div class="customer-info-box-wrapper">
                <div class="customer-info-box">
                  <template v-if="selectedCustomer === null">
                    <div class="no-preferences-wrapper">
                      <div class="select-customer-wrapper">
                        <b-form-group class="">
                          <ValidationProvider
                            name="Customer"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-select
                              v-model="selectedCustomer"
                              @input="getSelectedCustomer"
                              :options="customersList"
                            ></b-form-select>
                            <h6
                              class="font-sm font-family-regular position-relative danger mt-2"
                            >
                              {{ errors[0] }}
                            </h6>
                          </ValidationProvider>
                        </b-form-group>
                      </div>
                      <div class="no-preferences">
                        No Preferences
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="avatar-wrapper">
                      <Avatar :user="customerUser" size="6rem" />
                    </div>
                    <div class="customer-info-content">
                      <div class="customer-info-content-name">
                        {{ selectedCustomer.text }}
                      </div>
                      <div class="customer-info-content-email">
                        {{ selectedCustomer.customer.profile.user.email }}
                      </div>
                    </div>
                    <div class="controls-wrapper">
                      <div class="view-preferences-button-wrapper">
                        <b-button @click="openPreferencesSidebar"
                          >View Preferences</b-button
                        >
                      </div>
                      <b-form-group class="">
                        <ValidationProvider
                          name="Customer"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-form-select
                            v-model="selectedCustomer"
                            @input="getSelectedCustomer"
                            :options="customersList"
                          ></b-form-select>
                          <h6
                            class="font-sm font-family-regular position-relative danger mt-2"
                          >
                            {{ errors[0] }}
                          </h6>
                        </ValidationProvider>
                      </b-form-group>
                    </div>
                  </template>
                </div>
              </div>
            </b-row>
            <b-container fluid class="inner-container mt-5">
              <b-row>
                <b-col md="8" cols="12" id="main-fields">
                  <b-form>
                    <ValidationProvider
                      name="Title"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Title *" class="tasks-form-group">
                        <b-input-group>
                          <multiselect
                            placeholder="Add title of the task"
                            v-model="taskTitle"
                            label="text"
                            track-by="value"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            hideSelected
                            class="custom-multiselect mb-3"
                            :disabled="!isFormEnabled"
                            @select="onSelectTaskTitle"
                            :options="taskSuggestions"
                            :taggable="true"
                            @tag="onAddNewTitle"
                            tag-placeholder="Add this as a new Title"
                            data-cy="select-task-title"
                          >
                            <template
                              slot="singleLabel"
                              slot-scope="{ option }"
                            >
                              {{ ellipsify(option.text, 100) }}
                            </template>
                            <template slot="noResult"
                              >No suggestion found</template
                            >
                          </multiselect>
                        </b-input-group>
                        <h6
                          class="font-sm font-family-regular position-relative danger mt-2"
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                    <b-form-group
                      label="Description"
                      class="tasks-form-group mt-5"
                    >
                      <ValidationProvider
                        name="Description"
                        rules=""
                        v-slot="{ errors }"
                      >
                        <quill-editor
                          class="quill-custom"
                          :class="
                            !isFormEnabled ? 'grey-editor' : 'quill-editor'
                          "
                          ref="quillEditor"
                          v-model="taskDescription"
                          :disabled="!isFormEnabled"
                          :options="editorOptions"
                          data-cy="task-description"
                        />
                        <!-- <tiny-editor
                          v-model="taskDescription"
                          :disabled="!isFormEnabled"
                          :init="{
                            height: 450,
                            menubar: false,
                            plugins: [
                              'fullscreen link code lists',
                              'wordcount'
                            ],
                            toolbar: [
                              'bold italic underline strikethrough blockquote code link h1 h2\
                              numlist bullist outdent indent removeformat fontsizeselect forecolor backcolor alignleft aligncenter\
                              alignright alignjustify'
                            ]
                          }"
                        /> -->
                        <h6
                          class="font-sm font-family-regular position-relative danger mt-2"
                        >
                          {{ errors[0] }}
                        </h6>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group
                      label="Category *"
                      class="mt-5 tasks-form-group"
                    >
                      <ValidationProvider
                        name="Categories"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-input
                          v-if="invalidCustomer"
                          type="text"
                          placeholder="Select category"
                          :disabled="true"
                        >
                        </b-form-input>
                        <multiselect
                          v-else
                          placeholder="Select category"
                          @select="getSelectedCategories"
                          @remove="removeCategory"
                          :disabled="!isFormEnabled"
                          :class="[
                            !isFormEnabled ? 'multiselect-disabled' : null
                          ]"
                          v-model="selectedCategories"
                          label="text"
                          track-by="id"
                          selectLabel=""
                          deselectLabel=""
                          selectedLabel=""
                          class="custom-multiselect mb-3 categories-multiselect tasks-categories"
                          :options="categoriesList"
                          :multiple="true"
                          data-cy="task-category"
                        >
                          <template slot="singleLabel" slot-scope="props">
                            <span class="option__desc">
                              <span class="option__title">
                                {{ props.option.title }}
                              </span>
                            </span>
                          </template>
                        </multiselect>
                        <h6
                          class="font-sm font-family-regular position-relative danger mt-2"
                        >
                          {{ errors[0] }}
                        </h6>
                      </ValidationProvider>
                    </b-form-group>
                  </b-form>
                </b-col>

                <b-col id="task-properties" cols="12" md="4">
                  <b-form-group
                    label="Add Task Properties"
                    class="tasks-form-group"
                  >
                    <b-form-group>
                      <b-card
                        class="border-primary-lighter tasks-form-card"
                        no-body
                      >
                        <b-card-body
                          :class="{
                            'd-flex': true,
                            'form-disabled': !isFormEnabled,
                            'align-items-center': true
                          }"
                          style="padding:12px 12px"
                        >
                          <b-form-checkbox
                            size="lg"
                            style="bottom: 0.4rem"
                            class="checkbox ml-3"
                            name="check"
                            v-model="priority"
                            :disabled="!isFormEnabled"
                          ></b-form-checkbox>
                          <p
                            class="primary--text position-relative high-priority-text"
                          >
                            High Priority
                          </p>
                        </b-card-body>
                      </b-card>
                    </b-form-group>
                    <ValidationProvider
                      name="Due date field"
                      rules="date"
                      v-slot="{ errors }"
                    >
                      <b-form-group class="mt-5">
                        <b-input-group>
                          <b-form-input
                            id="example-input"
                            class="right-tasks-form-input"
                            placeholder="Due date"
                            v-model="dueDate"
                            :disabled="!isFormEnabled"
                            autocomplete="off"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-datepicker
                              right
                              :min="min"
                              :show-decade-nav="true"
                              v-model="dueDate"
                              :disabled="!isFormEnabled"
                              locale="en-US"
                              class="datepicker"
                              button-only
                              aria-controls="example-input"
                            >
                              <template #button-content="">
                                <img
                                  src="@/assets/icons/date-picker.svg"
                                  alt=""
                                />
                              </template>
                            </b-form-datepicker>
                          </b-input-group-append>
                        </b-input-group>
                        <h6
                          class="font-sm cy-new-intake-date-err mb-3 font-family-regular position-absolute danger"
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                    <b-form-group class="mt-5">
                      <b-card
                        no-body
                        :class="{
                          disabledCard: !isFormEnabled
                        }"
                        class="justify-content-center tasks-attachment-card"
                      >
                        <label
                          class="font-sm d-flex align-items-center justify-content-between cursor-pointer"
                        >
                          <p
                            class="primary--text position-relative d-inline add-attachment-top"
                          >
                            Add attachment
                          </p>
                          <img
                            src="@/assets/icons/form_attachment.svg"
                            alt=""
                          />
                          <input
                            type="file"
                            :accept="ACCEPTED_FILE_TYPES"
                            @change="fileChange"
                            ref="fileInput"
                            multiple
                            :disabled="!isFormEnabled"
                            class="d-none"
                          />
                        </label>
                      </b-card>
                      <h6 class="danger font-sm " v-if="sizeExceed">
                        Size cannot be greater than 500MB
                      </h6>
                    </b-form-group>
                    <b-form-group class="mb-0 mt-5">
                      <b-input-group @keypress.enter="createChecklist">
                        <b-form-input
                          autocomplete="off"
                          class="checklist-input"
                          size="lg"
                          :disabled="!isFormEnabled"
                          v-model="checklistValue"
                          placeholder="Add checklist"
                        ></b-form-input>
                        <b-input-group-append
                          class="position-absolute input-icon-container"
                        >
                          <img src="@/assets/icons/checklist.svg" alt />
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                    <b-form-group
                      label="Status *"
                      class="tasks-form-group status-field"
                    >
                      <ValidationProvider
                        name="Status"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-select
                          v-model="selectedStatus"
                          :options="statuses"
                          :disabled="!isFormEnabled"
                          @change="getSelectedStatus"
                          data-cy="select-status"
                        ></b-form-select>
                        <h6
                          v-if="errors[0]"
                          class="font-sm font-family-regular position-relative danger mt-2"
                        >
                          {{ errors[0] }}
                        </h6>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="Owner" class="tasks-form-group mt-5">
                      <multiselect
                        :value="selectedAssistant"
                        @select="getSelectedAssistant"
                        @remove="removeSelectedAssistant"
                        class="multiselect-handover"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :disabled="!isFormEnabled"
                        :class="[
                          !isFormEnabled ? 'multiselect-disabled' : null
                        ]"
                        :options="assistantsList"
                        track-by="id"
                        placeholder="Assign to"
                        label="text"
                        data-cy="select-owner"
                      >
                        <template slot="noResult">No PAs found</template>
                        <template slot="noOptions">No PAs found</template>
                      </multiselect>
                    </b-form-group>
                    <b-form-group
                      label="Frequency"
                      class="tasks-form-group status-field"
                    >
                      <b-form-select
                        v-model="selectedFrequency"
                        :options="frequenciesList"
                        :disabled="!isFormEnabled"
                      ></b-form-select>
                    </b-form-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row :style="{ flex: 1 }">
                <b-col cols="12" md="8">
                  <b-form>
                    <b-form-group
                      class="tasks-form-group"
                      label="Attachments"
                      v-if="attachments.length"
                    >
                      <AttachmentsComponent
                        :attachments="attachments"
                        @deleteAttachment="deleteAttachment"
                        @deleteImage="onDeleteImage"
                        :isFormEnabled="isFormEnabled"
                      />  
                    </b-form-group>
                    <b-form-group
                      label="Checklists"
                      class="tasks-form-group"
                      v-if="checklists.length"
                    >
                      <ChecklistComponent
                        :checklists="checklists"
                        :isFormEnabled="isFormEnabled"
                        @saveOption="saveChecklistOption"
                        @saveTitle="saveChecklistTitle"
                        @deleteChecklist="deleteChecklist"
                        @deleteOption="removeOption"
                      />
                    </b-form-group>
                    <b-row v-if="showValidity">
                      <div class="ml-4 form-invalid-error-container">
                        <p>There are invalid form fields</p>
                      </div>
                    </b-row>
                    <b-row v-else>
                      <div
                        class="form-valid-container ml-3"
                        v-if="successMessage"
                      >
                        <p>Task Created successfully</p>
                      </div>
                      <div
                        v-if="errorMessage"
                        class="form-invalid-error-container-2 ml-3"
                      >
                        <p>Some error occured</p>
                      </div>
                      <div
                        v-if="tokenError"
                        class="form-invalid-error-container-2 ml-3"
                      >
                        <p>
                          User token expired. Please logout and login again.
                        </p>
                      </div>
                    </b-row>
                  </b-form>
                </b-col>
              </b-row>
            </b-container>
          </b-container>
          <!-- only will be displayed on smaller screens -->
        </b-col>

        <!-- Right Side of screen with Customer select Dropdown and preferences for larger screens-->

        <b-col
          class="tasks tasks-right-container d-none d-xl-flex d-lg-none d-sm-none d-md-none flex-column mb-5"
        >
          <b-row class="mx-0 justify-content-center">
            <b-col md="11" class="p-0">
              <b-form-group class="mt-5">
                <ValidationProvider
                  name="Customer"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-select
                    data-cy="select-customer"
                    v-model="selectedCustomer"
                    @input="getSelectedCustomer"
                    :options="customersList"
                  ></b-form-select>
                  <h6
                    class="font-sm font-family-regular position-relative danger mt-2"
                  >
                    {{ errors[0] }}
                  </h6>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>
          <div
            class="ml-5 mt-2 mr-5 form-invalid-error-container cursor-pointer"
            v-if="notValidCustomer"
            @click="navigateToIntake()"
          >
            <p>
              Customer Intake must be completed before a task is created. Click
              here to complete intake.
            </p>
          </div>
          <div class="mb-4" v-else>
            <b-row
              @click="navigateToCustomerProfile"
              class="cursor-pointer mx-0 mt-3 d-flex"
              v-if="selectedCustomer"
            >
              <b-col md="3" class="d-flex justify-content-around px-0">
                <Avatar :user="customerUser" size="7rem" />
              </b-col>
              <b-col
                md="9"
                class="position-relative px-0 customer-details d-flex flex-column justify-content-center"
              >
                <p class="font-family-medium primary--text ml-2 mb-0">
                  {{
                    ellipsify(customerUser.firstName + '' + customerUser.lastName, 30)
                  }}
                </p>
                <p class="font-family-regular secondary--text ml-2 mb-0">
                  {{ ellipsify(customerUser.email, 30) }}
                </p>
              </b-col>
            </b-row>
          </div>
          <PreferencesComponent
            :notValidCustomer="notValidCustomer"
            :sidebarPreferences="sidebarPreferences"
          />
        </b-col>
        <!-- Right Side of screen with Customer select Dropdown and preferences for larger screens-->
      </ValidationObserver>
    </b-row>
    <!-- only will be displayed on smaller screens -->
    <TaskSidebarComponent
      :visible="preferencesSidebar.visible"
      @closeSidebar="closePreferencesSidebar"
      :sidebarPreferences="sidebarPreferences"
      :selectedCustomer="selectedCustomer"
    />
    <!-- only will be displayed on smaller screens -->
    <!-- Modal to display errors in case API throws any -->
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      v-model="errorModal.visible"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-container fluid>
        <b-button
          @click="errorModal.visible = false"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row align-v="center" class="px-2 py-2">
          <b-col md="9" class="d-flex mb-2">
            <h4 class="font-md subtext mt-2">
              {{ errorModal.message }}
            </h4>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <!-- Modal to display errors in case API throws any -->

    <b-row class="mt-3 save-button-row">
      <b-button
        class="save-button btn-pill px-5 py-3 mt-2 mb-5 ml-4"
        @click.prevent="createTask"
        v-if="!success"
        :disabled="disableFields"
        data-cy="task-save-btn"
      >
        <b-spinner
          v-if="pageLoading"
          style="width: 14px; height: 14px"
          variant="light"
          label="Spinning"
        ></b-spinner>
        {{ `${!pageLoading ? "Save" : ""}` }}
      </b-button>
      <b-button v-else class="btn-danger btn-pill px-5 py-3 mt-2 mb-5 ml-3">
        Saved
      </b-button>
    </b-row>
    <!-- Modal for confirmation of the handover assistant -->
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="showSelectionModal"
      data-cy="task-handover-pop-up"
    >
      <b-container fluid v-if="isAssign">
        <b-button
          @click="showSelectionModal = false"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row class="pt-2 pl-4 pr-4 d-flex flex-column">
          <h4 class="subtext mb-4 mt-3 ml-2">
            {{
              `Do you want to handover the task to the following ${
                assignAssistant.role.name === "admin" ? "admin" : "EA"
              } ?`
            }}
          </h4>
        </b-row>
        <b-row align-v="center">
          <b-col md="8" class="flex-row d-flex mb-4">
            <div>
              <Avatar :user="customerUser" size="8rem" />
            </div>
            <div
              class="d-flex flex-column justify-content-center position-relative ml-4"
            >
              <p class="font-family-medium primary--text mt-2">
                {{ assignAssistant.text }}
              </p>
            </div>
          </b-col>
          <b-button
            @click="assign"
            class="px-5 py-3 btn-pill reduce-whitespace ml-4"
            data-cy="assign-ea-btn"
          >
            Yes, Assign
          </b-button>
        </b-row>
      </b-container>
    </b-modal>
    <!-- Modal for confirmation of the handover assistant -->
  </div>
</template>

<script>
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
// import TinyEditor from "@tinymce/tinymce-vue";
import Multiselect from "vue-multiselect";
import { NOACTION, ACCEPTED_FILE_TYPES } from "@/utils/constants/index.js";
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
import TimerComponent from "@/components/timer/TimerComponent";
import Worker from "worker-loader!@/workers/TimerWorker.js";
import { editorOptions } from "@/utils/constants";
import { ellipsify } from "@/utils/utils";
extend("required", {
  message: () => "This is a required field"
});
let dateMessage = "YYYY-MM-DD format required";
extend("date", {
  message: () => dateMessage,
  validate: value => {
    let mustContainTheseChars = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars) {
      if (moment(value).isSameOrAfter(moment({ hour: 0 }))) {
        return true;
      } else {
        dateMessage = "Date cannot be from past";
        return false;
      }
    } else {
      dateMessage = "YYYY-MM-DD format required";
      return false;
    }
  }
});
import moment from "moment";
import {
  getCategories,
  getCategory,
  getTaskStatus,
  getTaskSuggestionList,
  getTeam,
  patchTracker,
  postAttachments,
  postTracker
} from "@/apis/common";
import {
  getActiveCustomers,
  getCategoryPreferences,
  postTask,
  postTaskAttachments,
  postTaskChecklist,
  postTaskComments,
  getCustomer,
  getAdminsActiveCustomers
} from "@/apis/customers";
import { mapState } from "vuex";
import {
  getAdminsDetails,
  getAssistantDetails,
  handOverTask
} from "@/apis/assistants";
import Avatar from "@/components/avatar/Avatar.vue";
import AttachmentsComponent from "@/components/attachments/AttachmentsComponent";
import ChecklistComponent from "@/components/checklists/ChecklistComponent";
import TaskSidebarComponent from "@/components/taskpreferences/TaskSidebarComponent";
import PreferencesComponent from "@/components/taskpreferences/PreferencesComponent";
import { getProfile } from "@/apis/auth";
import store from '@/store'

export default {
  name: "AddTask",
  components: {
    ValidationObserver,
    Multiselect,
    ChecklistComponent,
    Avatar,
    TimerComponent,
    ValidationProvider,
    quillEditor,
    // TinyEditor,
    AttachmentsComponent,
    TaskSidebarComponent,
    PreferencesComponent
  },
  computed: {
    ...mapState("authModule", ["role", "profileUserId"]),
    invalidCustomer() {
      return !this.selectedCustomer || this.notValidCustomer;
    },
    showControls() {
      return this.carouselData.length > 1 ? true : false;
    },
    quillInstance() {
      return this.$refs.quillEditor.quill;
    },
    isFormEnabled: {
      get: function() {
        return this.formEnabled;
      },
      set: function(stopAt) {
        this.formEnabled =
          this.selectedCustomer !== null && !this.notValidCustomer && !stopAt;
      }
    },
    sidebarPreferences() {
      return this.preferences
        .map(preference => {
          return {
            id: preference.categories.category.id,
            title: preference.categories.category.title,
            descriptions: preference.categories.preferences.map(
              pref => pref.detail
            )
          };
        })
        .filter(preference => {
          // don't show preferences which have no description content
          return preference.descriptions.length > 0;
        });
    },
    disableFields() {
      return this.pageLoading;
    }
  },
  data() {
    return {
      ACCEPTED_FILE_TYPES,
      errorModal: {
        visible: false,
        message: "File is empty. Cannot upload"
      },
      dirty: false,
      assignAssistant: "",
      showSelectionModal: false,
      stop: null,
      selectedAssistant: null,
      assistantsList: [],
      isAssign: false,
      tokenError: false,
      sizeExceed: false,
      editorOptions,
      newChecklistOption: "",
      newChecklistTitle: "",
      min: moment().format("YYYY-MM-DD"),
      priority: false,
      carouselData: [],
      startAt: "",
      stopAt: null,
      assistantProfileId: "",
      selectedCustomer: null,
      assistantFullName: "",
      customerFullName: "",
      dueDate: "",
      completionDate: "",
      selectedDate: "",
      duration: moment().startOf("day"),
      prevRouteParams: {},
      showPABreadcrumb: null,
      showCustomersBreadcrumb: null,
      customersList: [
        {
          value: null,
          text: "Select Customer"
        }
      ],
      formatted: "00:00:00",
      createdAt: null,
      timer: null,
      taskId: "",
      trackerId: "",
      showTimer: true,
      sliding: null,
      sliding2: null,
      stopped: null,
      selectedCategories: [],
      selectedStatus: null,
      customerUser: {},
      avatarName: "",
      customerID: "",
      selectedFrequency: "none",
      preferences: [],
      attachments: [],
      membership: "",
      checklistValue: "",
      checklists: [],
      taskDescription: "",
      undoRedoPressed: false,
      taskTitle: "",
      customerEmail: "",
      customerAvatar: null,
      showValidity: false,
      pageLoading: false,
      success: false,
      errorMessage: false,
      successMessage: false,
      totalApiCalls: [],
      preferencesExist: false,
      passedApiCalls: [],
      preferencesSidebar: {
        visible: false
      },
      commentValue: "",
      timerLog: {
        firstPost: true,
        trackerLog: []
      },
      frequenciesList: [
        {
          value: "none",
          text: "None"
        },
        {
          value: "daily",
          text: "Daily"
        },
        {
          value: "weekly",
          text: "Weekly"
        },
        {
          value: "monthly",
          text: "Monthly"
        },
        {
          value: "yearly",
          text: "Yearly"
        }
      ],
      statusID: "",
      taskStatuses: [],
      statuses: [
        {
          text: "Select Status",
          disabled: true,
        },
        {
          value: "complete",
          text: "Complete"
        },
        {
          value: "daily",
          text: "Daily"
        },
        {
          value: "in-progress",
          text: "In Progress"
        },
        {
          value: "later",
          text: "Later"
        },
        {
          value: "today",
          text: "Today"
        }
      ],
      categoriesList: [],
      comments: [],
      notValidCustomer: false,
      formEnabled: false,
      taskSuggestions: []
    };
  },
  watch: {
    preferencesExist() {
      if (this.preferencesExist) {
        this.preferences.forEach(item => {
          item.categories.preferences.map(el => {
            this.carouselData.push(
              `<div class="example-slide"><li class="font-size-sm w-75 pre-line">${el.detail}</li></div>`
            );
          });
        });
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === "PADetails") {
        vm.showPABreadcrumb = true;
        vm.prevRouteParams = from.params;
      } else if (from.name === "CustomerDetails") {
        vm.showCustomersBreadcrumb = true;
        vm.prevRouteParams = from.params;
      }
    });
  },
  created() {
    getTeam().then(res => {
      this.assistantsList = [...res.data.results]
        .filter(el => {
          if (el.id !== this.profileUserId) {
            return el;
          }
        })
        .map(item => {
          item.text = `${item.user.firstName} ${item.user.lastName}`;
          return item;
        });
    });
    this.getTaskNameSuggestion();
  },
  mounted() {
    if (this.$route.name === "AddCustomerTask") {
      this.showCustomersBreadcrumb = true;
    } else if (this.$route.name === "AddPATask") {
      this.showPABreadcrumb = true;
    } else if (this.$route.name === "AddPACustomerTask") {
      this.showCustomersBreadcrumb = true;
      this.showPABreadcrumb = true;
    }
    if (this.$route.params.profileId) {
      getCustomer(this.$route.params.profileId)
        .then(res => {
          let { firstName, lastName } = res.data.user;
          this.customerFullName = `${firstName} ${lastName}`;
        })
        .catch(err => {
          console.log(err);
        });
    }
    this.selectedFrequency = this.$route.params.frequency ? "daily" : "none";
    this.getCustomers();
    getCategories()
      .then(res => {
        this.categoriesList = [...res.data.results]
          .map(item => {
            item.text = item.title;
            return item;
          })
          .sort((a, b) => a.text.localeCompare(b.text));
      })
      .catch(err => {
        console.log(err);
      });
    getTaskStatus()
      .then(res => {
        this.taskStatuses = [...res.data.results].map(item => {
          item.text = item.title;
          item.value = item;
          return item;
        });
        this.taskStatuses.map(el => {
          if (el.id === this.$route.params.statusID) {
            this.selectedStatus = el.slug;
          }
        });
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    ellipsify,
    assign() {
      this.selectedAssistant = this.assignAssistant;
      this.showSelectionModal = false;
    },
    onBeforeUnload(event) {
      event.returnValue = "Some dummy value"
    },
    getCustomers() {
      if (this.profileUserId) {
        if (this.role === "assistant") {
          getAssistantDetails(this.profileUserId)
            .then(res => {
              let { firstName, lastName } = res.data.user;
              this.assistantFullName = `${firstName} ${lastName}`;
            })
            .then(() => {
              getActiveCustomers(this.profileUserId)
                .then(res => {
                  this.customersList = [...res.data.results].map(item => {
                    const dataValue = {...item}
                    dataValue.text = `${item.customer.profile.user.firstName} ${item.customer.profile.user.lastName}`;
                    dataValue.value = item;
                    return dataValue;
                  });
                  if (this.$route.params.profileId) {
                    this.selectedCustomer = this.customersList.filter(
                      el =>
                        el.customer.profile.id === this.$route.params.profileId
                    )[0];
                  }
                  this.customersList.unshift({
                    value: null,
                    text: "Select Customer"
                  });
                })
                .catch(err => {
                  console.log(err);
                });
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          getAdminsDetails(this.profileUserId)
            .then(res => {
              let { firstName, lastName } = res.data.user;
              this.assistantFullName = `${firstName} ${lastName}`;
            })
            .then(() => {
              getAdminsActiveCustomers(this.profileUserId)
                .then(res => {
                  this.customersList = [...res.data.results].map(item => {
                    const dataValue = {...item}
                      dataValue.text = `${item.customer.profile.user.firstName} ${item.customer.profile.user.lastName}`;
                      dataValue.value = item;
                      return dataValue;
                  });
                  if (this.$route.params.profileId) {
                    this.selectedCustomer = this.customersList.filter(
                      el =>
                        el.customer.profile.id === this.$route.params.profileId
                    )[0];
                  }
                  this.customersList.unshift({
                    value: null,
                    text: "Select Customer"
                  });
                })
                .catch(err => {
                  console.log(err);
                });
            })
            .catch(err => {
              console.log(err);
            });
        }
      } else {
        getProfile().then(res => {
          this.assistantProfileId = res.data.defaultProfile.id;
          if (this.role === "assistant") {
            getAssistantDetails(this.assistantProfileId)
              .then(res => {
                let { firstName, lastName } = res.data.user;
                this.assistantFullName = `${firstName} ${lastName}`;
              })
              .then(() => {
                getActiveCustomers(this.profileUserId)
                  .then(res => {
                    this.customersList = [...res.data.results].map(item => {
                      const dataValue = {...item}
                      dataValue.text = `${item.customer.profile.user.firstName} ${item.customer.profile.user.lastName}`;
                      dataValue.value = item;
                      return dataValue;
                    });
                    if (this.$route.params.profileId) {
                      this.selectedCustomer = this.customersList.filter(
                        el =>
                          el.customer.profile.id ===
                          this.$route.params.profileId
                      )[0];
                    }
                    this.customersList.unshift({
                      value: null,
                      text: "Select Customer"
                    });
                  })
                  .catch(err => {
                    console.log(err);
                  });
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            getAdminsDetails(this.assistantProfileId)
              .then(res => {
                let { firstName, lastName } = res.data.user;
                this.assistantFullName = `${firstName} ${lastName}`;
              })
              .then(() => {
                getAdminsActiveCustomers(this.profileUserId)
                  .then(res => {
                    this.customersList = [...res.data.results].map(item => {
                      const dataValue = {...item}
                      dataValue.text = `${item.customer.profile.user.firstName} ${item.customer.profile.user.lastName}`;
                      dataValue.value = item;
                      return dataValue;
                    });
                    if (this.$route.params.profileId) {
                      this.selectedCustomer = this.customersList.filter(
                        el =>
                          el.customer.profile.id ===
                          this.$route.params.profileId
                      )[0];
                    }
                    this.customersList.unshift({
                      value: null,
                      text: "Select Customer"
                    });
                  })
                  .catch(err => {
                    console.log(err);
                  });
              })
              .catch(err => {
                console.log(err);
              });
          }
        });
      }
    },
    handoverPAToClient() {
      if (this.stop === null) {
        const data1 = {
          action: "stop"
        };
        patchTracker(this.taskId, this.trackerId, data1)
          .then(res => {
            this.stopTimerThread()
            this.startedAt = moment(res.data.startAt).utc();
            this.stopped = moment(res.data.stopAt).utc();
            let dura = moment.duration(this.duration, "seconds");
            let Seconds = dura._data.seconds;
            if (Seconds < 10) {
              Seconds = `0${Seconds}`;
            }
            let Minutes = dura._data.minutes;
            if (Minutes < 10) {
              Minutes = `0${Minutes}`;
            }
            let Hours = dura._data.hours + dura._data.days * 24;
            if (Hours < 10) {
              Hours = `0${Hours}`;
            }
            this.formatted = `${Hours}:${Minutes}:${Seconds}`;
            const data = {
              task: this.taskId,
              requestedBy: this.profileUserId,
              assignedTo: this.assignAssistant.id,
              status: NOACTION
            };
            handOverTask(data)
              .then(() => {
                this.success = true;
                this.successMessage = true;
                store.commit({
                  type: 'removeUnloadListener',
                  onBeforeUnload: this.onBeforeUnload
                })
                this.dirty = false
                this.$router.go(-1);
                setTimeout(() => {
                  this.savedHandover = false;
                }, 2000);
              })
              .catch(err => {
                this.showAuthError = true;
                this.authMessage = err.response.data.detail;
              });
          })
          .catch(err => {
            this.showAuthError = true;
            this.authMessage = err.response.data.detail;
          });
      } else {
        const data = {
          task: this.taskId,
          requestedBy: this.profileUserId,
          assignedTo: this.assignAssistant.id,
          status: NOACTION
        };
        handOverTask(data)
          .then(() => {
            this.savedHandover = true;
            setTimeout(() => {
              this.savedHandover = false;
            }, 2000);
          })
          .catch(err => {
            this.showSaveIndicatorError();
            this.showAuthError = true;
            this.authMessage = err.response.data.detail;
          });
      }
    },
    removeSelectedAssistant() {
      this.selectedAssistant = null;
    },
    getSelectedAssistant(selected) {
      this.showSelectionModal = true;
      this.isAssign = true;
      this.assignAssistant = selected;
    },
    onContext() {},
    navigateToIntake() {
      this.$router.push({
        name: "ClientIntake",
        params: {
          profileId: this.selectedCustomer.customer.profile.id
        }
      });
    },
    getSelectedStatus(selected) {
      if (selected && selected === "complete") {
        this.stopTimer();
        this.completionDate = moment()
          .utc()
          .format("YYYY-MM-DD");
      } else {
        if (this.stopAt !== null) {
          this.startTimer();
        }
        this.completionDate = "";
      }
    },
    fileChange(event) {
      const extensions = this.ACCEPTED_FILE_TYPES
        .split(",")
        .filter(item => item[0] === '.');

      this.sizeExceed = false;
      let sizing = true;
      for (let i = 0; i < event.target.files.length; i++) {
        if (event.target.files[i].size / 1024 / 1024 > 500) {
          sizing = false;
          break;
        }
      }
      // empty file validation
      for (let file of event.target.files) {
        const fileExtension = `.${file.name.split(".").reverse()[0]}`
        const isRestrictedFileType = !extensions.includes(fileExtension)
        if (isRestrictedFileType) {
          this.errorModal.message = `${file.name} file format is not supported, please contact admin for more details.`;
          this.errorModal.visible = true;
          this.$refs.fileInput.value = "";
          return;
        }

        if (file.size === 0) {
          this.errorModal.message = `${file.name} is empty. Cannot upload.`;
          this.errorModal.visible = true;
          this.$refs.fileInput.value = "";
          return;
        }
      }
      if (sizing) {
        for (let i = 0; i < event.target.files.length; i++) {
          this.attachments.push(event.target.files[i]);
        }
        this.$refs.fileInput.value = "";
      } else {
        this.sizeExceed = true;
      }
    },
    addComment() {
      this.comments.push(this.commentValue);
      this.commentValue = "";
    },
    deleteAttachment(attachmentParams) {
      let attachmentIndex = attachmentParams[1];
      this.attachments.splice(attachmentIndex, 1);
    },
    removeCategory(removedOption) {
      this.attachments = this.attachments.filter(
        el => el.category !== removedOption.id
      );
      this.checklists = this.checklists.filter(
        el => el.category !== removedOption.id
      );
      this.preferences = this.preferences.filter(
        el => el.categories.category.id !== removedOption.id
      );

      for (let i = 0; i < this.preferences.length; i++) {
        if (this.preferences[i].categories.preferences.length) {
          this.preferencesExist = true;
          break;
        } else {
          this.preferencesExist = false;
        }
      }
    },
    deleteChecklist(index) {
      this.$delete(this.checklists, index);
    },
    removeOption(checklistIndex, index) {
      this.$delete(this.checklists[checklistIndex].options, index);
    },
    saveChecklistOption(
      newChecklistOption,
      checklistIndex,
      optionIndex,
      isNewOption
    ) {
      let checklist = this.checklists[checklistIndex];
      this.$set(checklist, "showNewOptionBox", false);
      if (isNewOption) {
        if (newChecklistOption.length > 0) {
          checklist.options.push({
            deletedAt: null,
            description: "",
            copiedFrom: checklist.category ? checklist.category : null,
            isChecked: false,
            title: newChecklistOption
          });
          this.newChecklistOption = "";
        } else {
          // if the user hasn't typed anything into the box, don't do anything, just exit
          return;
        }
      } else {
        let option = checklist.options[optionIndex];
        if (option.title.length > 0) {
          this.$set(option, "isEditing", false);
        } else {
          checklist.options = checklist.options.filter(
            (option, index) => index !== optionIndex
          );
        }
      }
    },
    createChecklist() {
      if (this.checklistValue.length === 0) {
        return;
      }
      let checklist = {
        title: this.checklistValue,
        options: [],
        isCopied: false,
        copiedFrom: null
      };
      this.checklists.push(checklist);
      this.checklistValue = "";
    },
    async createTask() {
      this.errorMessage = false;
      this.totalApiCalls.length = 0;
      this.passedApiCalls.length = 0;
      this.successMessage = false;
      this.showValidity = false;
      this.pageLoading = true;
      const valid = await this.$refs.addTaskRef.validate();
      if (valid) {
        let categories = [];
        for (let i = 0; i < this.selectedCategories.length; i++) {
          categories.push(this.selectedCategories[i].id);
        }
        this.taskStatuses.map(el => {
          if (el.slug === this.selectedStatus) {
            this.statusID = el.id;
          }
        });
        const data = {
          title: this.taskTitle.value,
          description: this.taskDescription,
          status: this.statusID,
          createdFor: this.customerID,
          categories: categories,
          dueDate: this.dueDate.length > 0 ? this.dueDate : null,
          assignedTo: this.profileUserId,
          completedDate:
            this.completionDate === "" ? null : this.completionDate,
          priority: this.priority ? "high" : "low",
          frequency: this.selectedFrequency
        };
        postTask(data)
          .then(async res => {
            this.timerLog.trackerLog.map(item => {
              item.task = res.data.id;
            });
            await postTracker(res.data.id, this.timerLog)
              .then(res => {
                let arr = res.data;
                this.stop = arr[arr.length - 1].stopAt;
                this.trackerId = arr[arr.length - 1].id;
              })
              .catch(() => {});
            this.taskId = res.data.id;
            this.passedApiCalls.push(true);
            for (let i = 0; i < this.attachments.length; i++) {
              if (this.attachments[i].name) {
                let myFile = new File(
                  [this.attachments[i]],
                  `${this.attachments[i].name}`
                );
                const formData = new FormData();
                formData.append("owner", this.profileUserId);
                formData.append("attachmentFile", myFile);
                postAttachments(formData)
                  .then(res => {
                    const data = {
                      task: this.taskId,
                      attachment: res.data.id
                    };
                    postTaskAttachments(this.taskId, data)
                      .then(() => {
                        this.passedApiCalls.push(true);
                      })
                      .catch(() => {})
                      .finally(() => {
                        this.totalApiCalls.push(true);
                        this.checkApis();
                      });
                  })
                  .catch(err => {
                    console.log(err);
                  });
              } else {
                const data = {
                  task: res.data.id,
                  attachment: this.attachments[i].attachment?.id,
                  copiedFrom: this.attachments[i].category
                    ? this.attachments[i].category
                    : null,
                  isCopied: this.attachments[i].id ? true : false
                };
                postTaskAttachments(this.taskId, data)
                  .then(() => {
                    this.passedApiCalls.push(true);
                  })
                  .catch(err => console.log(err))
                  .finally(() => {
                    this.totalApiCalls.push(true);
                    this.checkApis();
                  });
              }
            }
            for (let i = 0; i < this.checklists.length; i++) {
              for (let j = 0; j < this.checklists[i].options.length; j++) {
                delete this.checklists[i].options[j].id;
              }
              const data = {
                title: this.checklists[i].title,
                task: res.data.id,
                isCopied: this.checklists[i].id ? true : false,
                copiedFrom: this.checklists[i].category
                  ? this.checklists[i].category
                  : null,
                options: [...this.checklists[i].options]
              };
              data.options.forEach(
                (option, index) => (option.position = index + 1)
              );
              postTaskChecklist(this.taskId, data)
                .then(() => {
                  this.passedApiCalls.push(true);
                })
                .finally(() => {
                  this.totalApiCalls.push(true);
                  this.checkApis();
                });
            }
            for (let i = 0; i < this.comments.length; i++) {
              const data = {
                comment: this.comments[i],
                task: res.data.id,
                author: this.profileUserId
              };
              postTaskComments(this.taskId, data)
                .then(() => {
                  this.passedApiCalls.push(true);
                })
                .finally(() => {
                  this.totalApiCalls.push(true);
                  this.checkApis();
                });
            }
          })
          .catch(err => {
            if (err.response.status === 401) {
              this.tokenError = true;
            }
            console.log(err);
          })
          .finally(() => {
            this.totalApiCalls.push(true);
            this.checkApis();
          });
      } else {
        this.showValidity = true;
        this.pageLoading = false;
      }
    },
    getSelectedCustomer(selected) {
      this.timerLog.trackerLog = [];
      store.commit({
        type: 'attachUnloadListener',
        onBeforeUnload: this.onBeforeUnload
      })
      this.dirty = true
      this.duration = moment().startOf("day");
      if (selected === null) {
        this.notValidCustomer = false;
        this.selectedCategories = [];
        this.attachments = [];
        this.checklists = [];
        this.selectedStatus = 'today'
        this.completionDate = ""
      }
      if (selected) {
        if (selected.customer.profile.isProfileIntakeSubmitted) {
          this.notValidCustomer = false;
          this.stopTimerThread()
          this.formatted = "00:00:00";
          if (this.selectedStatus !== 'complete') {
            this.startTimer();
          }
          this.preferences = [];
          this.customerID = selected.customer.profile.id;
          this.customerUser = selected.customer.profile.user;
          this.customerEmail = selected.customer.profile.user.email;
          this.customerAvatar = selected.customer.profile.user.avatarThumbnail;
          this.membership = selected.customer.membership;
          if (this.selectedCategories.length) {
            const payload = [];
            this.selectedCategories.map(item => {
              payload.push(item.id);
            });
            let categoryIDs = payload.join(",");
            getCategoryPreferences(selected.customer.profile.id, categoryIDs)
              .then(res => {
                this.preferences = [...res.data.results];
              })
              .catch(err => console.log(err));
            for (let i = 0; i < this.preferences.length; i++) {
              if (this.preferences[i].categories.preferences.length) {
                this.preferencesExist = true;
                break;
              } else {
                this.preferencesExist = false;
              }
            }
          }
        } else {
          this.notValidCustomer = true;
          this.preferencesExist = false;
          this.preferences = [];
          this.checklists = [];
          this.stopTimerThread()
          this.formatted = "00:00:00";
        }
      } else {
        this.stopTimerThread()
        this.formatted = "00:00:00";
      }
    },
    async getSelectedCategories(selected) {
      // flag to check if preference has the checklist or need to load from category
      let getChecklistFromCategory = true;
      try {
        if (this.customerID !== "") {
          // holding execution untill we get the checklist from preferences, if any
          let res = await getCategoryPreferences(this.customerID, selected.id);
          this.preferences = [...this.preferences, ...res.data.results];
          if (res.data.results[0]?.categories?.preferencesChecklist?.length) {
            getChecklistFromCategory = false;
            let newChecklists =
              res.data.results[0].categories.preferencesChecklist;
            newChecklists.forEach(checklist => {
              checklist.category = selected.id;
            });
            this.checklists = [...this.checklists, ...newChecklists];
          }

          // to get preferences from category
          for (let i = 0; i < this.preferences.length; i++) {
            if (this.preferences[i].categories.preferences.length) {
              this.preferencesExist = true;
              break;
            } else {
              this.preferencesExist = false;
            }
          }
        }
      } catch (err) {
        console.log(err);
      }

      // getting checklists and attachments data from category after checking preferences
      getCategory(selected.id)
        .then(res => {
          this.attachments = [...this.attachments, ...res.data.attachments];

          // will get checklist from category only if preferences don't have any checklist for the category
          if (getChecklistFromCategory) {
            let categoryChecklists = res.data.checklists.map(checklist => {
              return {
                ...checklist,
                isCopied: true
              };
            });
            this.checklists = [...this.checklists, ...categoryChecklists];
          }
        })
        .catch(err => console.log(err));
    },
    saveChecklistTitle(index, newChecklistTitle) {
      let checklist = this.checklists[index];
      if (newChecklistTitle.length > 0) {
        checklist.title = newChecklistTitle;
      }
    },
    closePreferencesSidebar() {
      this.preferencesSidebar.visible = false;
    },
    openPreferencesSidebar() {
      this.preferencesSidebar.visible = true;
    },
    startTimer() {
      this.showTimer = true;
      this.timerLog.trackerLog.push({
        creator: this.profileUserId,
        startAt: moment()
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]"),
        stopAt: null
      });
      this.stopAt = null;
      this.startTimerThread();
      this.formEnabled = true;
    },
    stopTimer() {
      this.stopTimerThread()
      this.stopAt = moment()
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]");
      this.timerLog.trackerLog[
        this.timerLog.trackerLog.length - 1
      ].stopAt = this.stopAt;
      this.formEnabled = false;
    },
    startTimerThread() {
      if (window.Worker) {
        const worker = new Worker()
        this.worker = worker
        worker.postMessage({ 
          currentTime: this.duration.seconds(),
          action: 'start'
        })
        worker.addEventListener("message", () => {
          this.duration = moment(this.duration).add(1, "s");
          this.formatted = this.duration.format("HH:mm:ss")
        })
      } else {
        this.timer = setInterval(() => {
          this.duration = moment(this.duration).add(1, "s");
          this.formatted = moment(this.duration).format("HH:mm:ss");
        }, 1000);
      }
    },
    stopTimerThread() {
      if (window.Worker) {
        if (this.worker) {
          this.worker.terminate()
        }
      } else {
        clearInterval(this.timer);
      }
    },
    checkApis() {
      if (!this.tokenError) {
        if (
          this.totalApiCalls.length ===
          1 + this.attachments.length + this.checklists.length
        ) {
          this.pageLoading = false;
          if (this.passedApiCalls.length === this.totalApiCalls.length) {
            if (this.selectedAssistant) {
              this.handoverPAToClient();
            } else {
              this.success = true;
              this.successMessage = true;
              store.commit({
                type: 'removeUnloadListener',
                onBeforeUnload: this.onBeforeUnload
              })
              this.dirty = false
              this.$router.go(-1);
            }
          } else {
            this.errorMessage = true;
          }
        }
      } else {
        this.pageLoading = false;
      }
    },
    onDeleteImage(attachmentIndex) {
      this.attachments = this.attachments.filter(
        (attachment, index) => index !== attachmentIndex
      );
    },
    navigateToCustomerProfile() {
      let routeData = this.$router.resolve({
        name: "CustomerDetails",
        params: {
          profileId: this.customerID
        },
        query: {
          tab: 3
        }
      });
      window.open(routeData.href, "_blank");
    },
    navigateToCustomers() {
      if (
        this.$route.name === "AddPACustomerTask" ||
        this.$route.name === "AddPATask"
      ) {
        this.goToPAContactInfo();
      } else if (this.$route.name === "AddCustomerTask") {
        if (this.role === "admin") {
          this.$router.push({ name: "CustomersListAdmin", query: { tab: 0 } });
        } else if (this.role === "assistant") {
          this.$router.push({ name: "DedicatedCustomers" });
        }
      }
    },
    navigateToCustomerDetails() {
      if (
        this.$route.name === "AddPACustomerTask" ||
        this.$route.name === "AddPATask"
      ) {
        this.$router.push({
          name: "PACustomerDetails",
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          },
          query: {
            tab: 2
          }
        });
      } else if (this.$route.name === "AddCustomerTask") {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: this.$route.params.profileId
          },
          query: {
            tab: 2
          }
        });
      }
    },
    navigateToTasks() {
      if (this.$route.name === "AddPACustomerTask") {
        this.$router.push({
          name: "PACustomerDetails",
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          }
        });
      } else if (this.$route.name === "AddPATask") {
        this.goToPAContactInfo();
      } else if (this.$route.name === "AddCustomerTask") {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: this.$route.params.profileId
          },
          query: {
            tab: 0
          }
        });
      } else {
        this.$router.push({ name: "TaskDashboard" });
      }
    },
    goToPAContactInfo() {
      this.$router.push({
        name: "PADetails",
        params: {
          profileId: this.$route.params.profileId,
          uuid: this.$route.params.uuid
        },
        query: {
          tab: 1
        }
      });
    },
    async getTaskNameSuggestion() {
      let res = await getTaskSuggestionList();
      this.taskSuggestions = res.data.results.map(task => {
        return { value: task.title, text: task.title };
      });
    },
    onSelectTaskTitle(option) {
      this.taskTitle = option;
    },
    onAddNewTitle(newTag) {
      const tag = {
        value: newTag,
        text: newTag
      };
      this.taskTitle = tag;
    }
  },
  beforeDestroy() {
    store.commit({
      type: 'removeUnloadListener',
      onBeforeUnload: this.onBeforeUnload
    })
    if (window.Worker) {
      if (this.worker) {
        this.worker.terminate()
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.dirty || to.name === 'Login') {
      next()
    } else {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        next()
      } else {
        next(false)
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>;
<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";
.breadcrumb-container-left {
  left: 0;
}
.customer-details {
  right: 2%;
  overflow-wrap: break-word;
}
.disabledCard {
  background: #e9ecef;
  opacity: 1;
}
.preferences-card-wrapper {
  margin-bottom: 5rem;
  padding-right: 1.5rem;
}
.preferences-categories-card {
  border-radius: 10px;
}
.sidebar-preferences-wrapper {
  margin-bottom: 10rem;
}
.add-attachment-top {
  top: 0.8rem;
  // border: 1px solid #dcebf4 !important;
}
.tasks-attachment-card {
  width: inherit;
  border: 1px solid #dcebf4 !important;
  height: 4rem;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
.high-priority-text {
  margin: 2px;
}
.tasks-form-card {
  height: 4rem;
}
.comment-card-body {
  width: 30rem;
}
.tasks-vertical-divider {
  border-left: 1px solid $primary-lighter;
  top: 3rem;
}
.add-comment-input-box {
  height: 4rem;
  min-height: 4.4rem;
}
.remove-option-icon {
  right: 0.5rem;
}
.start-timer-btn {
  padding: 1rem 2rem !important;
}
.start-timer-btn p,
.timer-running-container p {
  // line-height: 1.8rem !important;
  color: #784f89;
  top: 1.3rem;
}

.checkbox-title-container {
  z-index: 0;
  top: 0.2rem;
}

.attachment-name {
  font-size: 1.5rem !important;
}

.show-timer p {
  top: 1.2rem;
}
.attachment-delete-btn,
.checklist-delete-btn {
}
.checklist-options-container {
  // height: 3rem;
  margin-bottom: 2.4rem;
}

.tasks-dropdown-divider {
  margin-top: 2.5rem;
}

.tasks-right-container {
  position: fixed;
  right: 0;
  z-index: 2;
  display: flex;
  // max-width: 21.66%;
  // flex: 0 0 21.66%;
  // width: 21.6%;
  top: 9rem;
  background: #fff;
  height: 100vh;
  overflow-y: auto;
}
.input-icon-container {
  right: 1rem;
  top: 1.2rem;
}
.box-container {
  height: 10rem;
  border-radius: 6px;
  // padding: 2rem;
  width: 15rem;
}

.show-timer-container {
  margin-top: -6rem;
}

.box-container a {
  opacity: 0.3;
}
.box-container.thumbnail-wrapper {
  > img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

.carousel-outer-container p {
  margin-top: 1rem;
}
.tasks-preferences {
  z-index: 100000;
  width: inherit;
}
.timer-resume {
  right: -1.5px;
  cursor: pointer;
}
.tasks-textarea {
  min-height: 17rem !important;
}
.status-field {
  margin-top: 40px;
}
.checklist-title-input {
  width: 80%;
  z-index: 5;
}
.checklist-title {
  z-index: 2;
  cursor: pointer;
}
.checklist-option-input-wrapper {
  flex: 1;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.save-button-row {
  padding-left: 30px;
  .save-button {
    background: $button-secondary;
  }
}
.form-disabled {
  background-color: $background-disabled;
}
.tasks-right-container select.custom-select {
  border-radius: 2.1rem;
  border-color: $primary-light;
}
.checklist-option-container p {
  line-height: 3rem;
 }
@media screen and (max-width: 991px) {
  .add-task-container {
    left: 0;
    width: 100%;
  }
  .add-task-container,
  .view-task-container {
    top: 18rem;
  }
}
@media screen and (max-width: 599px) {
  .add-task-container {
    height: 100vh;
  }
}
</style>
<style lang="scss">
@import "~@/scss/variables/colors.scss";
.tox-notifications-container {
  display: none;
}
.tox-toolbar {
  background: none !important;
  border-bottom: 1px solid $primary-lighter !important;
}
.tox-statusbar {
  display: none !important;
}
.tox-tinymce {
  border: 1px solid $primary-lighter !important;
  border-radius: 2.5px !important;
}
</style>
